import "nprogress/nprogress.css";
import "@mantine/core/styles.css";
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import React from 'react';
import { theme } from './src/theme';
import { Layout } from './src/components';
import { Providers } from './src/components/Providers';

export const wrapPageElement = ({ element, props, location }: any) => {
    return <Providers theme={theme} location={location}>
        <Layout {...props}>{element}</Layout>
    </Providers>;
};